export enum InvitationStep {
  USER_DETAILS = 'user-details',
  INVITATION_CODE = 'invitation-code'
}

